import { useSetSubjectLine } from '../state/actions/useSetSubjectLine';
import { useRemove } from '../state/actions/useRemove';
import { useSetTemplate } from '../state/actions/useSetTemplate';
import { useNavigateToEmailTemplates } from '../state/actions/useNavigateToEmailTemplates';
import { useGetHasMissingFieldsSelector } from '../state/selectors/useGetHasMissingFieldsSelector';
import { useIsInFlowSelector } from '../state/selectors/useIsInFlowSelector';
import { useGetSendEmailSelector } from '../state/selectors/useGetSendEmailSelector';
import { useGetSubjectLineSelector } from '../state/selectors/useGetSubjectLineSelector';
import { useGetTemplateSelector } from '../state/selectors/useGetTemplateSelector';
import { useAddSendEmailToWorkflow } from './useAddSendEmailToWorkflow';
import { useRemoveSendEmailFromWorkflow } from './useRemoveSendEmailFromWorkflow';
import { useOnMessageDragged } from './useOnMessageDragged';
import { useOnMessageDragEnd } from './useOnMessageDragEnd';
import { useUpdateSendEmailName } from '../state/actions/useUpdateSendEmailName';
import { useNameSelector } from '../state/selectors/useNameSelector';

export const useSendEmail = () => {
  const addToFlow = useAddSendEmailToWorkflow();
  const removeFromFlow = useRemoveSendEmailFromWorkflow();
  const setTemplate = useSetTemplate();
  const setSubjectLine = useSetSubjectLine();
  const remove = useRemove();
  const navigateToEmailTemplates = useNavigateToEmailTemplates();
  const onMessageDragged = useOnMessageDragged();
  const onMessageDragEnd = useOnMessageDragEnd();

  const isInFlow = useIsInFlowSelector();
  const getSendEmail = useGetSendEmailSelector();
  const getSubjectLine = useGetSubjectLineSelector();
  const getTemplate = useGetTemplateSelector();
  const getHasMissingFields = useGetHasMissingFieldsSelector();

  const setName = useUpdateSendEmailName();
  const getName = useNameSelector();

  return {
    addToFlow,
    removeFromFlow,
    setTemplate,
    setSubjectLine,
    remove,
    navigateToEmailTemplates,
    onMessageDragged,
    onMessageDragEnd,

    isInFlow,
    getSendEmail,
    getSubjectLine,
    getTemplate,
    getHasMissingFields,

    setName,
    getName,
  };
};
